import { render, staticRenderFns } from "./ErrorStatus.vue?vue&type=template&id=318499b2&"
import script from "./ErrorStatus.vue?vue&type=script&lang=js&"
export * from "./ErrorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports